export default function formatData(payload) {
    var result = {
        class: payload.class
    };

    //enum format data is different
    if (payload.class) {
        if (payload.class.indexOf("enum") !== -1) {
            result.properties = {};
            result.properties.value = payload.properties.value;

            return result;
        }
    }

    if (payload.entities) {
        result.entities = [];
        payload.entities.forEach(subEntity => {
            let toPush = {
                class: subEntity.class
            };

            if (subEntity.entities) {
                toPush.entities = subEntity.entities;
            }

            if (subEntity.properties) {
                toPush.properties = subEntity.properties;
            }

            result.entities.push(formatData(toPush));
        });
    } else {
        result.properties = {};
        result.properties.value =
            payload.properties && payload.properties.value ? payload.properties.value : null;
    }

    return result;
}
